'use client'

import { Component, type ErrorInfo, type ReactNode } from 'react'

import { ErrorBlock } from '@/components/common/ErrorBlock'

type Props = {
  children: ReactNode
  fallback?: ReactNode
  onError?: (error: Error, errorInfo: ErrorInfo) => void
}

type State = {
  hasError: boolean
}

export class ErrorBoundary extends Component<Props, State> {
  state: State = { hasError: false }

  static getDerivedStateFromError(): State {
    return { hasError: true }
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    this.props.onError?.(error, errorInfo)
  }

  render() {
    return this.state.hasError ? this.props.fallback || <ErrorBlock /> : this.props.children
  }
}
